<template>
  <section class="bg-black text-white py-16 md:py-24">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

      <h2 class="text-3xl md:text-4xl font-bold text-center">
        Descubra nossas 
        <br/>
        funcionalidades em <span class="text-orange-500"> 6 etapas</span>
      </h2>

      <div class="mt-16">
        <h3 class="text-center text-white font-semibold tracking-widest uppercase">
          Delivery
        </h3>
        <div class="mt-8 grid grid-cols-1 md:grid-cols-3 gap-12">
          <div v-for="feature in deliveryFeatures" :key="feature.title" class="text-center">
            <img :src="feature.imageSrc" alt="" class="rounded-lg shadow-lg w-full h-48 object-cover">
            <h4 class="mt-6 text-orange-500 text-xl font-bold">{{ feature.title }}</h4>
            <p class="mt-3 text-white text-sm leading-relaxed">
              {{ feature.description }}
            </p>
            <div class="h-0.5 w-24 bg-orange-500 mx-auto mt-3"></div>
          </div>
        </div>
      </div>

      <div class="mt-16">
        <h3 class="text-center text-white font-semibold tracking-widest uppercase">
          Presencial
        </h3>
        <div class="mt-8 grid grid-cols-1 md:grid-cols-3 gap-12">
          <div v-for="feature in presencialFeatures" :key="feature.title" class="text-center">
            <img :src="feature.imageSrc" alt="" class="rounded-lg shadow-lg w-full h-48 object-cover">
            <h4 class="mt-6 text-orange-500 text-xl font-bold">{{ feature.title }}</h4>
            <p class="mt-3 text-white text-sm leading-relaxed">
              {{ feature.description }}
            </p>
            <div class="h-0.5 w-24 bg-orange-500 mx-auto mt-3"></div>
          </div>
        </div>
      </div>

      <div class="mt-16 text-center">
        <router-link to="/planos"
          class="inline-block bg-orange-500 text-white font-semibold py-3 px-8 rounded-lg shadow-lg hover:bg-orange-600 transition-transform transform hover:scale-105">
          Faça sua conta gratuita
        </router-link>
      </div>

      <div class="mt-16 flex justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-orange-500 animate-bounce" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>

    </div>
  </section>
</template>

<script setup>
// O script permanece o mesmo

const deliveryFeatures = [
  {
    title: "1. Atendimento de imediato",
    description: "Gerencie todas as interações com clientes em um único lugar.",
    imageSrc: "https://i.ibb.co/dwqV9B1D/2-1.png"
  },
  {
    title: "2. Monitoramento em tempo real",
    description: "Acompanhe seus entregadores e otimize o tempo de entrega.",
    imageSrc: "https://i.ibb.co/Sw4F7vN3/2-2.png"
  },
  {
    title: "3. Relatórios detalhados",
    description: "Acesse insights essenciais para melhorar a eficiência e o desempenho do seu negócio.",
    imageSrc: "https://i.ibb.co/5g61MFD4/2-3.png"
  }
];

const presencialFeatures = [
  {
    title: "4. Atendimento à mesa",
    description: "Receba pedidos de forma rápida e fácil com nosso app.",
    imageSrc: "https://i.ibb.co/q3VYfG53/2-4.png"
  },
  {
    title: "5. Conexão direta com a cozinha",
    description: "Os pedidos são feitos automaticamente para agilizar a produção.",
    imageSrc: "https://i.ibb.co/cKPz4XJk/2-5.png"
  },
  {
    title: "6. Gerenciamento completo",
    description: "Acompanhe cada etapa, desde o pedido até a entrega.",
    imageSrc: "https://i.ibb.co/TBSznLHj/2-6.png"
  }
];
</script>